import { useEffect, useRef, useState, type ReactNode } from "react";
import { getRouteApi } from "@tanstack/react-router";

import type { FichaFocus } from "@/lib/labels";
import { cn } from "@/lib/utils";

const routeApi = getRouteApi("/_app/pessoa/$id");

export function FocusTarget({
	id,
	className,
	children,
}: {
	id: FichaFocus;
	className?: string;
	children: ReactNode;
}) {
	const focus = routeApi.useSearch({ select: (search) => search.focus });
	const ref = useRef<HTMLDivElement>(null);
	const [lit, setLit] = useState(false);

	useEffect(() => {
		if (focus !== id) {
			return;
		}

		ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
		setLit(true);

		const timer = setTimeout(() => setLit(false), 1600);

		return () => clearTimeout(timer);
	}, [focus, id]);

	return (
		<div
			ref={ref}
			data-focus={id}
			className={cn(
				"scroll-mt-24 rounded-lg transition-shadow",
				lit && "ring-2 ring-ring ring-offset-2 ring-offset-background",
				className,
			)}
		>
			{children}
		</div>
	);
}
